import { WebReportEvent, JsErrorReport } from '@slardar/sdk-web';
import BasePlugin from './base-plugin';

export default class EmptyErrorStackPlugin extends BasePlugin {
  handle(event: JsErrorReport) {
    const { payload } = event;
    const { error } = payload;
    // if stack is empty, modify js_error level to info
    payload.extra = {
      ...payload.extra,
      level: 'info',
    };
    // modify error name
    if (error.name && !error.name?.startsWith('[')) {
      error.name = `[info][EmptyErrorStack] - ${error.name}`;
    }
    return event;
  }

  shouldHandle(event: WebReportEvent): event is JsErrorReport {
    return event.ev_type === 'js_error' && Boolean(!event.payload.error.stack);
  }
}
